import { useState } from "react";
import { toast } from "../hooks/use-toast";
import api from "../services/api";
import { useNavigate } from "react-router-dom";
import { Home } from "lucide-react";

const AdminForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/password/send-code", { email });
      toast({
        title: "Email Sent",
        description: "Check your email for the verification code.",
      });
      navigate("/admin/verify-code", { state: { email } }); // pass email to next step
    } catch (err) {
      toast({
        title: "Error",
        description: err.response?.data?.message || "Failed to send code",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    try {
      sessionStorage.removeItem("user"); // clearer than clear("user")
      localStorage.removeItem("user"); // if used

      navigate("/", { replace: true });
    } catch (err) {
      console.error("Home failed");
    }
  };

  return (
    <div className="container-custom py-20">
      <div className="max-w-md mx-auto bg-card p-8 rounded-2xl shadow-soft">
        <h2 className="text-xl font-semibold mb-4">Forgot Password</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="email"
            placeholder="Your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full px-4 py-3 rounded-xl border border-border focus:border-primary outline-none"
          />
          <button type="submit" className="btn-hero w-full" disabled={loading}>
            {loading ? "Sending..." : "Send Verification Code"}
          </button>
        </form>
      </div>
      <button onClick={handleLogout} className="btn-hero w-full">
        <Home size={20} />
        <span>Back to Site</span>
      </button>
    </div>
  );
};

export default AdminForgotPassword;
